import { css } from 'emotion';

import { colors, fonts } from '../styles';

export const close = css`
  padding-left: 30px;
  width: 230px;
`;

export const closeTitle = css`
  position: relative;
  margin-bottom: 10px;
`;

export const closeTitleIcon = css`
  color: ${colors.warning.default};
  position: absolute;
  right: calc(100% + 10px);

  && {
    font-size: ${fonts.size.larger};
  }
`;

export const closeActions = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;

  > :last-child {
    margin-left: 30px;
  }
`;
